module.exports = __webpack_public_path__ + "img/headportrait_1_icon.0d81b130.png";